<template>
  <div class="custom-tree-container">
    <el-row class="content-bottom-padded" style="padding-top:15px;margin-left:20px">
      <el-col>
        <el-button type="primary" icon="plus" @click="updateCategory" size="mini" :disabled="isDisable">保存修改</el-button>
      </el-col>
    </el-row>

    <div class="block">
      <ul class="custom-tree-node-title">
        <li>Id</li>
        <li>名称</li>
        <li>排序</li>
        <li>操作</li>
      </ul>
    </div>
    <div class="tree-background block">

      <el-tree v-loading="loading" :data="list" default-expand-all :expand-on-click-node="false">
        <ul class="custom-tree-node" slot-scope="{ node, data }">
          <li>{{data.category_id}}</li>
          <li>
            <input placeholder="名称"   v-model="data.name"/>
          </li>
         <li>
            <span style="padding-right:100px"><input style="width:50px" placeholder="排序" v-model="data.sort"/></span>
         </li>
        <li>
            <span class="remove-category" @click="deleteCategory(node, data)">
              <i class="iconfont icon-trash-alt"></i>
            </span>
        </li>
        </ul>
      </el-tree>
      <div class="add-category">
        <span @click="append(list)"><i class="el-icon-plus"></i>新增</span>
      </div>
    </div>

  </div>
</template>
<script>
import {getCategoryList, saveCategory, updateCategory, deleteCategory} from '@/api/long'

export default {
  components: {
  },
  data() {
    return {
      isDisable: false,
      loading: false,
      spaceInput: false,
      list: [],
      total_count: 0,
      attrParams: {
        page: 1,
        pageSize: 20,
      },
      params: [],
      dialogLoading: false,
      relAttrvisible: false,
      goodsAttr: [],
      checkGoodsAttr: [],
      currentNode: 0,
      currentAttrType: '',
      currentList: []
    }
  },
  methods: {
    handleCurrentChange (page) {
      this.attrParams.page = page
      this.getGoodsAttr()
    },
    handleSizeChange (pageSize) {
      this.attrParams.page = 1
      this.attrParams.pageSize = pageSize
      this.getGoodsAttr()
    },
    handleDialogAttr(data, type, node) {
      this.dialogLoading = true
      this.relAttrvisible = true
      this.currentAttrType = type
      this.currentNode = node
      this.currentList = data
      this.attrParams.page = 1
      this.attrParams.pageSize = 20

    },
    selectAll(data) {
      this.$message({ type: 'error', message: '绑定不支持全选' })
      this.toggleRowSelection()
    },
    toggleRowSelection() {
      this.$refs.multipleTable.clearSelection();

      var checkids = []
      this.checkGoodsAttr.forEach(item => {
        checkids.push(item.attribute_id)
      })

      this.goodsAttr.forEach(item => {
        if (checkids && checkids.indexOf(item.attribute_id) !== -1) {
          this.$refs.multipleTable.toggleRowSelection(item)
        }
      })
    },

    handleCancel () {
      this.relAttrvisible = false
      this.dialogLoading = false
      this.attrParams.page = 1
      this.attrParams.pageSize = 20
      this.goodsAttr = []
      this.checkGoodsAttr = []
      this.currentAttrType = ''
      this.currentList = []
    },
    getlist() {
      this.loading = true
      getCategoryList(this.params).then(response => {
        this.list = response.data.data
        this.loading = false
        this.spaceInput = false
      })
    },
    updateCategory() {
      for (var i = 0; i < this.list.length; i++) {
        for (var a = 0; a < this.list.length - 1 - i; a++) {
          if(this.list[a].name == this.list[a+1].name) {
            this.$message({
              type: 'error',
              message: '同级分类不能相同'
            })
            return false
          }
        }

        if (!this.catNameCheck(this.list[i].name)) {
          return false
        }

        for (var j = 0; j < this.list[i].children.length; j++) {
          for (var b = 0; b < this.list[i].children.length - 1 - j; b++) {
            if(this.list[i].children[b].name == this.list[i].children[b+1].name) {
              this.$message({
                type: 'error',
                message: '同级分类不能相同'
              })
              return false
            }
          }
          if (!this.catNameCheck(this.list[i].children[j].name)) {
            return false
          }
        }
      }
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false
      }, 1000)
      let form = JSON.stringify(this.list)
      saveCategory({form: form}).then(response => {
        this.$message({
          type: 'success',
          message: '保存成功'
        })
        this.getlist()
      })
    },
    deleteCategory(node, data) {
      this.$confirm('此操作将删除该, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (typeof (data.category_id) != 'undefined') {
          deleteCategory(data.category_id).then(response => {
            this.$message({
              type: 'success',
              message: '删除成功'
            })
            this.getlist()
          })
        } else {
          const parent = node.parent;
          const children = parent.data.children || parent.data;
          const index = children.findIndex(d => d.id === data.id);
          children.splice(index, 1);
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    noUse(){
      this.$message({
        type: 'info',
        message: '该功能已被禁用'
      })
      return false;
    },
    append(data, sort= 0) {
      var new_sort = sort + 1
      const newChild = {name: '', sort: 0, sort: new_sort, children: [], created: -1}
      data.push(newChild)
    },
    catNameCheck (catName) {
      let catNameLength = 0
      if(catName) {
        for (var i=0; i < catName.length; i++) {
          if (catName.charCodeAt(i) > 255) {
            catNameLength += 2;
          } else {
            catNameLength ++ ;
          }
        }
        if(catNameLength > 50) {
          this.$message({
            type: 'error',
            message: '分类长度最多25个汉字或50个字符'
          })
          return false
        }
        return true
      } else {
        this.$message({
          type: 'error',
          message: '分类不能为空'
        })
        return false
      }
    },

  },

  mounted() {
    this.getlist()
  }
};
</script>

<style scoped lang="scss">

.sku-value {
  margin-right: 10px;
}

.custom-tree-container {
  background-color: #fff;
}

.tree-background {
  padding-bottom: 45px;
  margin: 0px 20px;
}

.custom-tree-node, .custom-tree-node-title {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
  li {
    display: inline-block;
    text-align: center;
    width: 25%;
  }
  li:first-child {
    text-align: left;
  }
  li.category-icon {
    display: flex;
    align-items: middle;
    justify-content: center;
    span {
      height: 30px;
    }
    img {
      width: auto;
      height: 30px;
    }
  }
}

.custom-tree-node-title {
  font-weight: bold;
  color: #909399;
  margin: 0px 20px;
  li {
    padding: 12px 0;
  }
}

.add-category {
  margin-left: 25px;
  margin-top: 30px;
  span {
    cursor: pointer;
  }
}

.remove-category {
  margin-left: 10px;
}

.add-child-category {
  margin-left: 10px;
}
</style>
<style lang="scss">
.custom-tree-container {
  .el-tree-node__content{
    height: 45px;
    padding: 0px;
    line-height: 45px;
  }
  .el-tree > .el-tree-node {
    position: relative;
    &::after {
      position: absolute;
      height: 1px;
      left: 0;
      right: 0;
      bottom: 0;
      content: "";
      background-color: #e6e6e6;
    }
  }
  .el-tree > .el-tree-node:first-child {
    &::before {
      position: absolute;
      height: 1px;
      left: 0;
      right: 0;
      top: 0;
      content: "";
      background-color: #e6e6e6;
    }
  }
}

.custom-tree-node {
  input {
    border: 1px solid #ddd;
    line-height: 25px;
    padding-left: 5px;
    width: 150px;
  }
}

</style>



// WEBPACK FOOTER //
// index.vue?142dabd3